export type NativeNavigationEvent = {
  altKey: boolean
  button: number
  ctrlKey: boolean
  defaultPrevented: boolean
  metaKey: boolean
  preventDefault: () => void
  shiftKey: boolean
}

export function shouldUseNativeNavigation(event: NativeNavigationEvent) {
  return event.defaultPrevented || event.button !== 0 || event.metaKey || event.altKey || event.ctrlKey || event.shiftKey
}
